import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AirportAlert } from '../models/airport-alert.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '../service/alert.service';
var EditAlertComponent = /** @class */ (function () {
    function EditAlertComponent(_matDialogRef, data, _alertService) {
        this._matDialogRef = _matDialogRef;
        this._alertService = _alertService;
        this.isNew = false;
        this.isLoading = false;
        this.alert = data.alert || new AirportAlert();
        this.isNew = data.isNew || false;
        if (this.isNew) {
            this.alert.code = '';
            this.alert.website = '';
            this.alert.priority = AirportAlert.parseAlertPriority('Low');
            this.alert.effectiveDate = new Date();
            this.alert.expirationDate = new Date();
            this.selectedPermanent = false;
            this.selectedHidden = false;
        }
        this.airportID = data.airID;
        this.originalAlert = Object.assign(new AirportAlert(), data.alert);
        this.itemsToChange = new Set();
        this.selectedTitle = this.alert.title || '';
        this.selectedDescription = this.alert.description || '';
        this.selectedPriority = AirportAlert.formatAlertPriority(this.alert.priority);
        this.selectedWebsite = this.alert.website;
        if (this.alert.effectiveDate === null) {
            this.selectedPermanent = false;
            this.selectedHidden = true;
            this.selectedEffectiveDate = new Date();
            this.selectedExpirationDate = this.alert.expirationDate;
        }
        else if (this.alert.expirationDate === null) {
            this.selectedPermanent = true;
            this.selectedHidden = false;
            this.selectedEffectiveDate = new Date();
        }
        else {
            this.selectedEffectiveDate = this.alert.effectiveDate;
            this.selectedExpirationDate = this.alert.expirationDate;
            this.selectedPermanent = false;
            this.selectedHidden = false;
        }
    }
    EditAlertComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            title: new FormControl(this.selectedTitle, [Validators.required]),
            description: new FormControl(this.selectedDescription, [Validators.required]),
            priority: new FormControl(this.selectedPriority, [Validators.required]),
            effectiveDate: new FormControl({ effectiveDate: this.selectedEffectiveDate, disabled: this.selectedPermanent }),
            expirationDate: new FormControl({ expirationDate: this.selectedExpirationDate, disabled: this.selectedPermanent }),
            website: new FormControl(this.selectedWebsite),
            hide: new FormControl(this.selectedHidden),
            permanent: new FormControl(this.selectedPermanent)
        });
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditAlertComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        res = void 0;
                        this.alert.description = this.formGroup.get('description').value.replace(/[^\w\s~!@#$%^&*()_|+\-=?;:'",.<>{}\[\]\\\/]/gi, '');
                        if (this.alert.description) {
                            this.alert.description = this.alert.description.trim();
                        }
                        this.alert.priority = AirportAlert.parseAlertPriority(this.formGroup.get('priority').value.toLowerCase());
                        this.alert.title = this.formGroup.get('title').value.replace(/[^\w\s~!@#$%^&*()_|+\-=?;:'",.<>{}\[\]\\\/]/gi, '');
                        this.alert.website = this.formGroup.get('website').value;
                        this.alert.effectiveDate = this.formGroup.get('effectiveDate').value;
                        this.alert.expirationDate = this.formGroup.get('expirationDate').value;
                        this.selectedHidden = this.formGroup.get('hide').value;
                        this.selectedPermanent = this.formGroup.get('permanent').value;
                        if (this.selectedPermanent) {
                            this.alert.expirationDate = null;
                            this.alert.priority = 1;
                        }
                        if (this.selectedHidden) {
                            this.alert.effectiveDate = null;
                        }
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._alertService.postAirportAlert(this.airportID, this.alert)];
                    case 1:
                        res = _a.sent();
                        this.alert = AirportAlert.parse(res);
                        return [3 /*break*/, 4];
                    case 2:
                        if (this.originalAlert.effectiveDate === this.alert.effectiveDate ||
                            this.originalAlert.expirationDate === this.alert.expirationDate) {
                            this.close({ cancelBtnClicked: false, success: true, alert: this.alert });
                        }
                        return [4 /*yield*/, this._alertService.putAirportAlert(this.airportID, this.alert)];
                    case 3:
                        res = _a.sent();
                        Object.assign(this.alert, AirportAlert.parse(res));
                        this.alert = AirportAlert.parse(res);
                        console.log(this.alert.effectiveDate);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, alert: this.alert });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditAlertComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditAlertComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.alert, this.originalAlert);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    EditAlertComponent.prototype.clickPermanent = function () {
        if (!this.selectedHidden) {
            this.selectedExpirationDate = null;
        }
    };
    return EditAlertComponent;
}());
export { EditAlertComponent };
